export * from './colors';
export * from '../../utils/constants/regions';

export const registrationUrl = 'https://upr-dostup.uchi.ru/';
export const supportEmail = 'support_kabmun-uchi@vk.team';
export const OLYMPIADS_MAX_BOT_URL = 'https://max.ru/gr_olympiads_statistic_bot';
export const OLYMPIADS_TELEGRAM_BOT_URL = 'https://t.me/gr_olympiads_statistic_bot';
